module.exports = __webpack_public_path__ + "img/0f32a32.png";